import React, { useState, useEffect } from 'react';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import 'rc-datepicker/lib/style.css';
import { ManagementPrompt } from '../../Res/ManagementPrompt';
import { Pagination } from '../../Res/Pagination';
import { ContentBox } from '../../Content/ContentBox';
import { ReqModule, RespModuleItem } from '../../../../item/ItemModule';
import { uuid } from '../../../../item/ItemTools';
import { setResume2Token, setVal2Token } from '../../../Login/Auth';
import { api_getMoudleList } from '../../../../api/apiModule';
import { api_getModulePermissionList } from '../../../../api/apiModulePermissiony';
import { RespModulePermissionListItem } from '../../../../item/ItemModulePermission';

export function ModulePermissionList({ type, setIsLoading }) {
    const [moudleList, setMoudleList] = useState([])


    useEffect(() => {
        toSearch()
    }, [])

    function toSearch() {
        //console.log("toSearch")
        getModulePermissionList()
    }


    async function getModulePermissionList() {
        setIsLoading(true)
        api_getModulePermissionList({
            success: (obj) => {
                console.log(obj)
                var list = []
                obj.list.map(item => {
                    // console.log(item)
                    var mRespModulePermissionListItem = new RespModulePermissionListItem({})
                    mRespModulePermissionListItem.fromJson(item)
                    list.push(mRespModulePermissionListItem)
                })
                console.log(list)
                setMoudleList(list)
                setIsLoading(false)
            },
            failure: (err) => {
                //console.log(err)
                setIsLoading(false)
            }
        })
    }

    function toAdd() {
        window.location.assign("/ModuleAdd");
    }


    var baseTitle = "模組列表"
    var baseContent =
        <>
            <div className="row m-b-sm">
            </div>
            <ListBox list={moudleList}  sp={toSearch} type={type} />
        </>

    var title_tools =
        <a className="dropdown-toggle " data-toggle="dropdown" href="#A" onClick={e => toAdd()}>
            <i className="fa fa-pencil text-warning"></i><span className="text-warning m-l-xs">新增</span>
        </a>

    return (
        <>
            <ContentBox title={baseTitle} title_tools={title_tools} content={baseContent} hasDrawer={false} />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}


function ListBox({ list, type }) {
    const [moduleList, setModuleList] = useState([])
    const [tableList, setTableList] = useState([])


    useEffect(() => {
        if (list !== undefined && moduleList !== list) {
            setModuleList(list)
        }

    }, [list])

    useEffect(()=>{
        setTableList(setTable())
    },[moduleList])

    function setTable() {
        var items = []
        moduleList.forEach((item, index) => {
            console.log(item)
            items.push(<ModulePermissionBox key={item.applyId} item={item} />)
        });
        // console.log(moduleList)
        return items
    }

    if (tableList.length === 0) {
        return (<></>)
    } else {
        //console.log(managerList)
        return (
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-3">帳號</th>
                                    <th className="text-center sorting col-sm-3">暱稱</th>
                                    <th className="text-center sorting col-sm-6">已授權模組</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    tableList.map((item) => (
                                        item
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }

}

function ModulePermissionBox({ item }) {
    const [modulePermission, setModulePermission] = useState({})
    const [applyId, setApplyId] = useState("")
    const [nickName, setNickName] = useState("")
    const [mobile, setMobile] = useState("")
    const [items, setItems] = useState([])

    useEffect(() => {
        if (item !== undefined && item !== modulePermission) {
            setModulePermission(item)
            setApplyId(item.applyId)
            setNickName(item.nickName)
            setMobile(item.mobile)
            setItems(item.items)
        }
    }, [item])

    function toEdit(){
        var tokenId = uuid(128, 64)
        setVal2Token('modulePermission', modulePermission, tokenId)
        window.location.replace("/ModulePermissionEdit/"+tokenId);
    }

    return (
        <tr role="row">
            <td className="text-center"><a href="#A" onClick={e=>toEdit()}>{nickName}&nbsp;</a></td>
            <td className="text-center">{mobile}</td>
            <td className="">
                <div className="row">
                    <div className="col-sm-12" style={{overflowY: 'scroll', maxHeight:'100px'}}>
                {
                    items.map(item =>
                        (
                            <div key={item.moduleId} className="col-sm-12">
                                {item.moduleName}
                            </div>
                        )
                    )
                }
                </div>
            </div>
            </td>
        </tr>
    )
}
